import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button,
	Typography,
	Fade,
	Collapse
} from "@mui/material";
import {
	Timeline,
	TimelineItem,
	TimelineSeparator,
	TimelineConnector,
	TimelineContent,
	TimelineDot
} from "@mui/lab";
import { timelineItemClasses } from '@mui/lab/TimelineItem';
import { useState, useEffect } from "react";
import GradientLogo from '../../assets/images/GradientLogo.png';

const steps = [
	{
		emoji: "📱",
		title: "Sign Up with OTP",
		description: "Quickly sign up using your phone number. We verify with a simple OTP."
	},
	{
		emoji: "📝",
		title: "Create Your Profile",
		description: "Fill in your profile details. Some fields are mandatory, others optional. Fill in all details to improve the odds of finding a match."
	},
	{
		emoji: "🔎",
		title: "Profile Verification",
		description: "On a need basis, our team will verify your profile details to maintain platform quality."
	},
	{
		emoji: "🎉",
		title: "Profile Visibility",
		description: "Once verified, your profile will be visible to all members for browsing."
	},
	{
		emoji: "💎",
		title: "Upgrade for Full Access",
		description: "You can take an annual subscription to view onboarded profiles and connect with prospects that match your criteria."
	}
];

const IntroModal = ({ open, handleClose }) => {
	const [showText, setShowText] = useState(false);

	useEffect(() => {
		if (open) {
			const timeout = setTimeout(() => setShowText(true), 200); // Delay for smooth effect
			return () => clearTimeout(timeout);
		} else {
			setShowText(false);
		}
	}, [open]);

	return (
		<Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
			<DialogTitle>
				<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
					<img src={GradientLogo} alt="GSB Soirika Logo" style={{ height: '60px', marginBottom: '8px' }} />
					Welcome to GSB Soirika 🚀
				</div>
			</DialogTitle>

			<DialogContent dividers sx={{ backgroundColor: "#f9f9f9" }}>
				<Fade in={showText} timeout={1500}>
					<Typography variant="subtitle1" fontWeight="medium" align="center" mb={2}>
						Here's a quick overview of your journey with GSB Soirika, step-by-step.
					</Typography>
				</Fade>
				<Collapse in={showText} timeout={800}> 
					<Timeline
						position="right"
						sx={{
							[`& .${timelineItemClasses.root}:before`]: {
								flex: 0,
								padding: 0,
							},
						}}
					>
						{steps.map((step, index) => (
							<TimelineItem key={index}>
								<TimelineSeparator>
									<TimelineDot color="primary" variant="outlined">
										<span style={{ fontSize: "1.5rem" }}>{step.emoji}</span>
									</TimelineDot>
									{index !== steps.length - 1 && <TimelineConnector />}
								</TimelineSeparator>

								<TimelineContent>
									<Typography variant="h6" fontWeight="bold" gutterBottom>
										{step.title}
									</Typography>
									<Typography variant="body2" color="textSecondary">
										{step.description}
									</Typography>
								</TimelineContent>
							</TimelineItem>
						))}
					</Timeline>
				</Collapse>
				
			</DialogContent>

			<DialogActions>
				<Button variant="contained" color="primary" onClick={handleClose}>
					Got it, Continue
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default IntroModal;
